import { useEffect, useState } from "react";
import clearStorage from "@utils/storage";
import { addUserEmailHashToGTM } from "@utils/GTM/addUserEmailHashToGTM";
import { keycloakUtils, onLoadOptionsType } from "src/itsf/keycloak/keycloakUtils";
import { useTwoWayAuth } from "@features/TwoWayAuth/hook/useTwoWayAuth";

export const useKeycloak = (onLoadOption: onLoadOptionsType) => {
    const [isKeycloakReady, setIsKeycloakReady] = useState(false);
    const { handleCheckIfValidated } = useTwoWayAuth();

    useEffect(() => {
        try {
            keycloakUtils.init(onLoadOption, {
                checkLoginIframe: process.env.NODE_ENV !== "development",
            });

            keycloakUtils.setOnAuthSuccess(async () => {
                await addUserEmailHashToGTM();
            });

            keycloakUtils.setOnAuthLogout(() => {
                clearStorage();
            });

            keycloakUtils.setOnReady(async () => {
                await handleCheckIfValidated();
                setIsKeycloakReady(true);
            });
        } catch (keycloakError) {
            setIsKeycloakReady(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { isKeycloakReady };
};
